import React from 'react';

const Center = ({ children }) => (
  <div className="str-chat__list__center">{children}</div>
);

export default React.memo(Center);